export default {
    modal: {
        title: "You've hit a limit",
        body: 'To keep going, delete an older one.',
        counter: 'Used: {current} / {limit}',
        contact: 'Think this is a mistake? Get in touch with us.',
        close: 'Got it',
    },
    chip: {
        title: 'Account limit',
        note: 'Some resources have usage limits on your account.',
    },
}
